import GenerateIFrame from 'wrapper/lib/frames/GenerateIFrame'
import RemoveIFrame from 'wrapper/lib/frames/RemoveIFrame'
import DisplayIFrame from 'wrapper/lib/frames/DisplayIFrame'
import ToggleIFrame from 'wrapper/lib/frames/ToggleIFrame'
import DeleteIFrame from 'wrapper/lib/frames/DeleteIFrame'
import FrameError from 'wrapper/lib/frames/FrameError'

import { removeToken, saveToken } from 'wrapper/lib/hostMutations/tokens'
import WindowFunctions from 'wrapper/lib/hostMutations/WindowFunctions'
import handleLinkClient from 'wrapper/lib/hostMutations/LinkClient'

// Mutations - Augment host page with data or functions (i.e. Signals, Triggers, etc...)
const MessageBroker = (message, data, done = () => {}) => {
    if (!message) {
        // eslint-disable-next-line no-console
        console.warn('MessageBroker Called with no message', data)
    } else {
        GenerateIFrame(message, data)
        RemoveIFrame(message, data)
        DisplayIFrame(message, data)
        ToggleIFrame(message, data)
        DeleteIFrame(message, data)
        FrameError(message, data)

        removeToken(message, data)
        saveToken(message, data)
        WindowFunctions(message, data)
        handleLinkClient(message, data)
    }

    done(message, data)
}

export default MessageBroker
